import React from "react";
import { Tooltip } from "@material-ui/core";
import Loading from "../../components/Loading";
import HelpIcon from "@material-ui/icons/Help";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import * as Constants from "../../constants/constants";
import { updateVideo } from "../../Redux/Actions/videos";
import "./style.css";

interface IProps {
  updateVideo: (video: any) => void;
  isVideoUpdating: boolean;
  loading: boolean;
  match: any;
  video: any;
}

class Detail extends React.Component<IProps> {
  state = {
    description: "",
    typingTimeout: 0,
    descriptionLoaded: false,
  };

  componentDidUpdate() {
    if (this.props.video && this.props.video.description && !this.state.descriptionLoaded) {
      this.setState({ description: this.props.video.description, descriptionLoaded: true });
    }
  }

  updateDescription = (e: any) => {
    let that = this;
    clearTimeout(this.state.typingTimeout);
    this.setState({
      description: e.target.value,
      typingTimeout: setTimeout(() => {
        that.triggerUpdate(that.state.description);
      }, 2000),
    });
  };

  triggerUpdate = (value: any) => {
    const { id } = this.props.match.params;
    this.props.updateVideo({ id, description: value });
  };

  render() {
    const { loading } = this.props;
    return (
      <div>
        {loading && <div className="progressEditing"><Loading /></div>}
        <label id="descriptionLabel">{Constants.DESCRIPTION}</label>
        <textarea
          name="textarea"
          value={this.state.description}
          className="descriptionTextArea"
          onChange={this.updateDescription}
          placeholder="Add a description for your video..."
        />
        <p style={{ fontSize: 13, color: "#98a2b3", marginTop: 8 }}>
          {Constants.ADD_TEXT}
          <Tooltip title="Appears on video page" placement="top" arrow>
            <span style={{ marginLeft: 4, verticalAlign: "middle" }}><HelpIcon style={{ fontSize: 16 }} /></span>
          </Tooltip>
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  loading: state.video.loading,
  isVideoUpdating: state.video.isVideoUpdating,
  video: state.video.singleVideo,
});
const mapDispatchToProps = (dispatch: any) => ({
  updateVideo: (video: any) => dispatch(updateVideo(video)),
});
export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(Detail));
